'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _systemItem = require('@/components/system-item');

var _systemItem2 = _interopRequireDefault(_systemItem);

var _privateLetter = require('@/components/private-letter');

var _privateLetter2 = _interopRequireDefault(_privateLetter);

var _list = require('@/components/list');

var _list2 = _interopRequireDefault(_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'message',
  inject: ['setVisible'],
  data: function data() {
    return {
      system: [],
      message: [],
      systemCount: 0,
      messageCount: 0,
      tabActive: 'system',
      loadding: true,
      messageLoadding: false
    };
  },

  components: {
    List: _list2.default
  },
  created: function created() {
    this.getSystemList();
    this.getMessageList();
    this.SystemItem = _systemItem2.default;
    this.PrivateLetter = _privateLetter2.default;
  },

  computed: {
    // 获取阅读消息后更新列表
    messageReady: function messageReady() {
      return this.$store.state.message.ready;
    }
  },
  methods: {
    // 获取系统消息列表
    getSystemList: function getSystemList() {
      var _this = this;

      this.$ajax({
        url: '/api-message/portal/notifyrecord/findNotifyRecordListSelf?queryReceiverState=2',
        method: 'GET'
      }).then(function (res) {
        if (res.status == 200) {
          _this.system = res.data.data;
          _this.systemCount = res.data.count;
          _this.loadding = false;
          _this.setMessageCount();
        }
      });
    },

    // 私信
    getMessageList: function getMessageList() {
      var _this2 = this;

      this.$ajax({
        url: '/api-message/portal/messagedialogue/findAllDialogueRecordList',
        method: 'GET'
      }).then(function (res) {
        if (res.status == 200) {
          _this2.message = res.data.data;
          _this2.messageCount = res.data.count;
          _this2.messageLoadding = false;
          _this2.setMessageCount();
        }
      });
    },
    onAll: function onAll() {
      this.$router.push({
        path: '/usercenter/myMessage'
      });
    },
    setMessageCount: function setMessageCount() {
      this.$emit('messageCount', this.messageCount + this.systemCount);
    },

    // 设置对应的数据为已读
    onCancel: function onCancel() {
      var _this3 = this;

      var result = [];
      var urlMap = {
        message: '/api-message/portal/messagedialogue/updateReadMessage',
        system: '/api-message/mobile/notifyrecord/updateNotifyReceiverState'
      };
      this[this.tabActive].forEach(function (item) {
        result.push(item.messageId || item.mesNotifyId);
      });
      this.$ajax({
        url: urlMap[this.tabActive],
        method: 'PUT',
        data: {
          messageIds: result,
          mesNotifyId: result
        }
      }).then(function (res) {
        if (res.status == 200) {
          _this3.tabActive == 'system' ? _this3.getSystemList() : _this3.getMessageList();
        }
      });
    },
    onClickMessageItem: function onClickMessageItem() {
      this.setVisible();
    },
    onclickItem: function onclickItem() {
      this.setVisible();
    }
  },
  watch: {
    tabActive: function tabActive() {
      if (this.tabActive == 'system') {
        this.getSystemList();
      } else {
        this.getMessageList();
      }
    },

    messageReady: {
      deep: true,
      handler: function handler() {
        var _this4 = this;

        setTimeout(function () {
          if (_this4.messageReady.type == 'message') {
            _this4.getMessageList();
          }
          if (_this4.messageReady.type == 'system') {
            _this4.getSystemList();
          }
        }, 2000);
      }
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//